
import React, { useState } from 'react';
import { assets } from '../assets/assets';
import axios from 'axios';
import { backendUrl } from '../App';
import { toast } from 'react-toastify';

const Add = ({ token }) => {
  const [image1, setImage1] = useState(false);
  const [image2, setImage2] = useState(false);
  const [image3, setImage3] = useState(false);
  const [image4, setImage4] = useState(false);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("Men");
  const [subCategory, setSubCategory] = useState("Topwear");
  const [bestseller, setBestseller] = useState(false);
  const [sizes, setSizes] = useState([]);

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("description", description);
      formData.append("price", price);
      formData.append("category", category);
      formData.append("subCategory", subCategory);
      formData.append("bestseller", bestseller);
      formData.append("sizes", JSON.stringify(sizes));
      image1 && formData.append("image1", image1);
      image2 && formData.append("image2", image2);
      image3 && formData.append("image3", image3);
      image4 && formData.append("image4", image4);

      const response = await axios.post(backendUrl + '/api/product/add', formData, { headers: { token } });

      if (response.data.success) {
        toast.success(response.data.message);
        setName('');
        setDescription('');
        setPrice('');
        setImage1(false);
        setImage2(false);
        setImage3(false);
        setImage4(false);
        setSizes([]);
        setBestseller(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  const sizeOptions = ["S", "M", "L", "X", "XL", "XXL"];

  return (
    <form onSubmit={onSubmitHandler} className="container my-4">
      {/* Upload Images */}
      <div className="mb-3">
        <p>Upload Image</p>
        <div className="d-flex flex-wrap gap-2">
          {[image1, image2, image3, image4].map((img, index) => (
            <label key={index} htmlFor={`image${index + 1}`}>
              <img
                src={!img ? assets.upload_area : URL.createObjectURL(img)}
                alt=""
                style={{ cursor: 'pointer', width: '8rem', height: '8rem', objectFit: 'cover' }}
              />
              <input
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (index === 0) setImage1(file);
                  if (index === 1) setImage2(file);
                  if (index === 2) setImage3(file);
                  if (index === 3) setImage4(file);
                }}
                type="file"
                id={`image${index + 1}`}
                hidden
              />
            </label>
          ))}
        </div>
      </div>

      {/* Product Name */}
      <div className="mb-3">
        <p>Product Name</p>
        <input
          onChange={(e) => setName(e.target.value)}
          value={name}
          className="form-control"
          type="text"
          placeholder="Type here"
          required
        />
      </div>

      {/* Product Description */}
      <div className="mb-3">
        <p>Product Description</p>
        <textarea
          onChange={(e) => setDescription(e.target.value)}
          value={description}
          className="form-control"
          placeholder="Write content here"
          required
        />
      </div>

      {/* Category, Subcategory, Price */}
      <div className="row mb-3">
        <div className="col-12 col-md-4">
          <p className="mb-1">Product Category</p>
          <select onChange={(e) => setCategory(e.target.value)} className="form-select">
            <option disabled>Select--</option>
            <option value="Men">Men</option>
            <option value="Women">Women</option>
            <option value="Kids">Kids</option>
          </select>
        </div>

        <div className="col-12 col-md-4">
          <p className="mb-1">Product SubCategory</p>
          <select onChange={(e) => setSubCategory(e.target.value)} className="form-select">
            <option disabled>Select--</option>
            <option value="Topwear">Topwear</option>
            <option value="Bottomwear">Bottomwear</option>
            <option value="Winterwear">Winterwear</option>
          </select>
        </div>

        <div className="col-12 col-md-4">
          <p className="mb-1">Product Price</p>
          <input
            onChange={(e) => setPrice(e.target.value)}
            value={price}
            type="number"
            className="form-control"
            placeholder="Enter price"
          />
        </div>
      </div>

      {/* Sizes */}
      <div className="mb-3">
        <p>Product Sizes</p>
        <div className="d-flex flex-wrap gap-2">
          {sizeOptions.map((size) => (
            <div key={size} onClick={() => setSizes((prev) =>
              prev.includes(size) ? prev.filter(item => item !== size) : [...prev, size]
            )}>
              <p className={`px-3 py-1 rounded ${sizes.includes(size) ? 'bg-danger' : 'bg-secondary'} text-white`} style={{ cursor: 'pointer' }}>
                {size}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Bestseller Checkbox */}
      <div className="form-check mb-3">
        <input
          onChange={() => setBestseller(prev => !prev)}
          checked={bestseller}
          type="checkbox"
          id="bestseller"
          className="form-check-input"
        />
        <label htmlFor="bestseller" className="form-check-label" style={{ cursor: 'pointer' }}>
          Add to Bestseller
        </label>
      </div>

      {/* Submit Button */}
      <div className="row">
  <div className="col-12 col-md-3">
    <button className="btn btn-dark w-100" type="submit">
      ADD
    </button>
  </div>
</div>

    </form>
  );
};

export default Add;



